import { Column } from 'src/shared/components/Semantic/all'
import { useLocalization } from 'src/shared/hooks/useLocalization'
import { NavigationButtons } from './NavigationButtons'

export const TestimonialsHeader = ({
  showNav,
  onPrevious,
  onNext,
}: {
  showNav: boolean
  onPrevious?: () => void
  onNext?: () => void
}) => {
  const { t } = useLocalization()

  return (
    <Column className="w-full items-center gap-4 text-center">
      <Column className="min-w-0 items-center gap-2">
        <span className="text-md font-normal uppercase tracking-wide">
          {t('Testimonials', 'Omdömen')}
        </span>

        <h2 className="text-4xl tracking-tight text-slate-900 md:text-5xl">
          {t(
            'For teams that cannot afford a wrong order',
            'För team som inte har råd med en felaktig order'
          )}
        </h2>
      </Column>

      {showNav && onPrevious && onNext ? (
        <NavigationButtons onPrevious={onPrevious} onNext={onNext} />
      ) : null}
    </Column>
  )
}
